import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

// Stylesheets
import './style.scss';

const propTypes = {
    className: PropTypes.string,
    noPadding: PropTypes.bool,
};

const defaultProps = {
    className: '',
    noPadding: false,
};

const Page = (props) => {
    const { noPadding, className } = props;
    return (
        <div className={cx('Page', { 'Page-no-padding': noPadding }, className)}>
            {props.children}
        </div>
    );
};

Page.propTypes = propTypes;
Page.defaultProps = defaultProps;

export { Page };
export default Page;
